import TableLayout from '../../../../layout/main/TableLayout'
import { Column, Flex, Relative, Row } from '../../../../../styles/CommonStyles'
import Text from '../../../../../core/utils/Text'
import DateTime from '../../../../common/utils/DateTime'
import UserLink from '../../../../common/utils/UserLink'
import useGetTableIndex from '../../../../../core/hooks/layout/useGetTableIndex'

import { recipientsAttributes } from '../../../../../core/constants/headers'
import Operation from '../../../../common/utils/Operation'
import { useNavigate } from 'react-router-dom'

const RecipientsTable = ({ data }) => {
    const { data: recipients } = data
    const { cs, headers } = recipientsAttributes
    const { getTableIndex } = useGetTableIndex()
    const navigate = useNavigate();

    return (
        <TableLayout headers={headers} cs={cs} data={data}>
            {recipients?.data?.map((item, idx) => {
                const label = item.label

                return (
                    <Relative key={item._id}>
                        <Row cs={cs} index={idx}>
                            {/* INDEX */}
                            <Column>{getTableIndex(idx)}</Column>

                            {/* USER */}
                            <Column avatar>
                                <UserLink
                                    _id={item.userId}
                                    name={item.userId}
                                />
                            </Column>

                            {/* LABEL */}
                            <Column avatar>
                                <Text tid={label} />

                            </Column>

                            {/* ACCOUNT ID */}
                            <Column>
                                <Text tid={item.accountId} />
                            </Column>

                            {/* STATUS */}
                            <Column>
                                <Text tid={item.meta?.isActive ? 'active' : 'inactive'} />
                            </Column>

                            {/* CREATED AT */}
                            <Column>
                                <DateTime dt={item.createdAt} />
                            </Column>
                        </Row>

                        <Column operation>
                            <Operation
                                hasWriteAccess
                                hasDetails
                                onDetailsClicked={() => { navigate(`/reports/due-payments/recipients/${item._id}`) }}
                            />
                        </Column>
                    </Relative>
                )
            })}
        </TableLayout>
    )
}

export default RecipientsTable